<template>
  <div>
    <!-- 
			Data, desktop's view
		-->
    <a-row>
      <a-col :span="6" v-for="i in data" :key="i.mcu">
        <a-card
          :bordered="false"
          style="margin-bottom: 20px; margin-left: 10px"
        >
          <template #title>{{ i.name }}</template>
          <a-row>
            <a-col :span="12">Room</a-col>
            <a-col :span="12" align="right">{{ i.name }}</a-col>
          </a-row>
          <a-row>
            <a-col :span="12">MCU</a-col>
            <a-col :span="12" align="right">{{ i.mcu }}</a-col>
          </a-row>
          <a-row>
            <a-col :span="12">IP</a-col>
            <a-col :span="12" align="right">{{ i.ip }}</a-col>
          </a-row>
          <a-row>
            <a-col :span="10">Health</a-col>
            <a-col :span="14" align="right">{{
              i.mcuUpdate !== undefined
                ? i.mcuUpdate.replace("T", " ").substring(0, 19)
                : ""
            }}</a-col>
          </a-row>
          <a-divider />
          <a-row>
            <a-col :span="12">Status</a-col>
            <a-col :span="12" align="right">
              <a-tag v-if="i.status === 'Enable'" color="green">Yes</a-tag>
              <a-tag v-else color="red">No</a-tag>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">Always on</a-col>
            <a-col :span="12" align="right">
              <a-tag v-if="i.open === true" color="green">Yes</a-tag>
              <a-tag v-else color="red">No</a-tag>
            </a-col>
          </a-row>
          <a-divider />
          <div style="margin-top: 10px; width: 100%">
            <center>
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Open Door</span>
                </template>
                <a-button
                  type="default"
                  shape="circle"
                  icon="unlock"
                  @click="onOpen(i)" /></a-tooltip
              >&nbsp;
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Close Door</span>
                </template>
                <a-button
                  type="default"
                  shape="circle"
                  icon="lock"
                  @click="onClose(i)" /></a-tooltip
              >&nbsp;
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Always On</span>
                </template>
                <a-button
                  type="default"
                  shape="circle"
                  icon="play-circle"
                  @click="onAlwaysOn(i)" /></a-tooltip
              >&nbsp;
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Check Status</span>
                </template>
                <a-button
                  type="default"
                  shape="circle"
                  icon="check"
                  @click="onRefreshStatus(i)" /></a-tooltip
              >&nbsp;
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Reboot MCU</span>
                </template>
                <a-button
                  type="default"
                  shape="circle"
                  icon="redo"
                  @click="onRestart(i)"
              /></a-tooltip>
            </center>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import searchRoomAdvance from "../../components/Search/SearchRoomAdvance";
import tools from "../../utils/tools";

export default {
  //
  //
  //
  components: {
    searchRoomAdvance
  },
  //
  //
  //
  data() {
    return {
      data: []
    };
  },
  //
  //
  //
  beforeCreate() {
    if (!tools.isLogin()) this.$router.push("/login");
  },
  //
  //
  //
  created() {},
  //
  //
  //
  beforeMounted() {},
  //
  //
  //
  mounted() {
    if (!tools.isLogin()) return;
    this.requestData();
  },
  //
  //
  //
  beforeUpdated() {},
  //
  //
  //
  updated() {},
  //
  //
  //
  beforeDestroy() {},
  //
  //
  //
  destroyed() {},
  //
  //
  //
  methods: {
    //
    //
    //
    onOpen(item) {
      axios
        .post(
          process.env.VUE_APP_INVENTORY_API + "/rooms/mcus/control/open",
          {
            mcu: item.mcu
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {})
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    //
    //
    onClose(item) {
      axios
        .post(
          process.env.VUE_APP_INVENTORY_API + "/rooms/mcus/control/close",
          {
            mcu: item.mcu
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          this.requestData();
        })
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    //
    //
    onAlwaysOn(item) {
      axios
        .post(
          process.env.VUE_APP_INVENTORY_API + "/rooms/mcus/control/alwaysOn",
          {
            mcu: item.mcu
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          this.requestData();
        })
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    //
    //
    onRefreshStatus(item) {
      axios
        .post(
          process.env.VUE_APP_INVENTORY_API + "/rooms/mcus/control/status",
          {
            mcu: item.mcu
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {})
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    //
    //
    onRestart(item) {
      axios
        .post(
          process.env.VUE_APP_INVENTORY_API + "/rooms/mcus/control/restart",
          {
            mcu: item.mcu
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {})
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    // Request data.
    //
    requestData() {
      axios
        .get(process.env.VUE_APP_INVENTORY_API + "/rooms/mcus", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          this.data = response.data.data;
        })
        .catch(error => {
          console.log(error);
          return;
        });
    }
  }
};
</script>

<style lang="scss"></style>
